import React, { useEffect, useState } from 'react';
//import 'bootstrap/dist/css/bootstrap.min.css';
import { FaDownload, FaPrint, FaStore } from 'react-icons/fa';
import { Modal, Button } from 'react-bootstrap';
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';
import axios from 'axios';
import { InvoiceURL, mainImageURI } from '../../components/assets/constants/Urls/Url';
import { useLocation, useParams, useNavigate } from 'react-router-dom';
import { useTheme } from '../../components/assets/context/ThemeContex';

const InvoicePage = () => {
  const location = useLocation();
  const [showModal, setShowModal] = useState(false);
  const [invoice, setInvoice] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const invoiceNumber = location.state?.invoice;
  const { invoiceId } = useParams();
  const navigate = useNavigate();
  const { theme } = useTheme();

  // Raw inputs
  const price = 0
  const total = 0

  // Fetching the invoice
  useEffect(() => {
    const getInvoice = async () => {
      setIsLoading(true);
      try {
        const response = await axios.get(`${InvoiceURL}${invoiceId}`);
        if (response.data) {
          setInvoice(response.data);
        }
      } catch (error) {
        console.error('Error fetching invoice:', error);
      } finally {
        setIsLoading(false);
      }
    };

    getInvoice();
  }, [invoiceId]);

  // Download, print, and navigation functions
  const handleDownloadClick = () => setShowModal(true);
  const handleCloseModal = () => setShowModal(false);
  const handlePrint = () => window.print();
  const handleGoToMarket = () => (window.location.href = '/');

  // Function to wait for images before capturing
  const captureInvoice = () => {
    const invoiceElement = document.getElementById('invoice');

    if (!invoiceElement) {
      console.error('Invoice element not found');
      return;
    }

    html2canvas(invoiceElement, { scale: 2, useCORS: true }).then((canvas) => {
      const imgData = canvas.toDataURL('image/png');
      const pdf = new jsPDF('p', 'mm', 'a4');
      
      const imgWidth = 210; // A4 width in mm
      const pageHeight = 297; // A4 height in mm
      const imgHeight = (canvas.height * imgWidth) / canvas.width; 

      let y = 0;
      while (y < imgHeight) {
        pdf.addImage(imgData, 'PNG', 0, y * -1, imgWidth, imgHeight);
        y += pageHeight;
        if (y < imgHeight) pdf.addPage();
      }

      pdf.save(`invoice_${invoiceId}.pdf`);
    });

    handleCloseModal();
  };

  const handleDownloadPDF = () => {
    const invoiceElement = document.getElementById('invoice');

    if (!invoiceElement) return;

    // Wait for images to fully load
    const images = invoiceElement.getElementsByTagName('img');
    let loadedImages = 0;
    const totalImages = images.length;

    if (totalImages === 0) {
      captureInvoice(); // If no images, proceed with capture
      return;
    }

    for (let img of images) {
      img.onload = () => {
        loadedImages++;
        if (loadedImages === totalImages) {
          captureInvoice();
        }
      };
      img.onerror = () => {
        loadedImages++;
        if (loadedImages === totalImages) {
          captureInvoice();
        }
      };
    }
  };

  const handleDownloadImage = () => {
    const invoiceElement = document.getElementById('invoice');

    if (!invoiceElement) return;

    html2canvas(invoiceElement, { useCORS: true }).then((canvas) => {
      const imgData = canvas.toDataURL('image/png');
      const link = document.createElement('a');
      link.href = imgData;
      link.download = `invoice_${invoiceId}.png`;
      link.click();
    });

    handleCloseModal();
  };

  return (
    <div
      className="container my-5"
      style={{
        background: "var(--background)",
        color: "var(--textMain)"
      }}
    >
      {/* Loading Spinner */}
      {isLoading ? (
        <p>Loading invoice...</p>
      ) : invoice ? (
        <>
          {/* Invoice Info and Action Buttons */}
          <div className="d-flex justify-content-between align-items-center mb-4">
            <div className="d-flex">
              <button
                className="btn me-2"
                style={{
                  background: "var(--cardBackground)",
                  color: "var(--primary)",
                  border: `1px solid var(--primary)`
                }}
                onClick={handleDownloadClick}
              >
                <FaDownload /> Download
              </button>
              <button
                className="btn me-2"
                style={{
                  background: "var(--cardBackground)",
                  color: "var(--textMain)",
                  border: `1px solid var(--dividerLine)`
                }}
                onClick={handlePrint}
              >
                <FaPrint /> Print
              </button>
              <button
                className="btn"
                style={{
                  background: "var(--primary)",
                  color: "var(--background)",
                  border: `1px solid var(--primary)`
                }}
                onClick={handleGoToMarket}
              >
                <FaStore /> Back to Market
              </button>
            </div>
          </div>

          {/* Invoice Details */}
          <div
            className="card p-4 invoice-download-area"
            id="invoice"
            style={{
              background: '#fff',
              color: '#222',
              border: '1px solid #eee',
              borderRadius: 12,
              maxWidth: '100%',
              overflowX: 'auto',
              boxShadow: '0 2px 8px rgba(0,0,0,0.06)'
            }}
          >
            <div className="text-center mb-4">
              <h2 style={{ color: '#D4AF37' }}>TimeLib</h2>
              <p style={{ color: '#888' }}>www.timelib.com | timelib1@gmail.com | +231 886 222 600</p>
            </div>
            <div className="row" style={{ display: 'flex', flexWrap: 'wrap', gap: '1em' }}>
              <div style={{ flex: 1, minWidth: 220 }}>
                <h5 style={{ color: '#222' }}>Invoice Number: {invoiceId}</h5>
                <p style={{ color: '#888' }}>Order Date: {new Date(invoice.order_date).toLocaleDateString()}</p>
              </div>
              <hr style={{ width: '100%' }} />
              <div className="col-md-6" style={{ flex: 1, minWidth: 220 }}>
                <h5 style={{ color: '#222' }}>Billing Information</h5>
                <p><strong>Name:</strong> {invoice.shipping_name}</p>
                <p><strong>Address:</strong> {invoice.shipping_address}</p>
                <p><strong>Phone:</strong> {invoice.shipping_contact}</p>
              </div>
              <div className="col-md-6" style={{ flex: 1, minWidth: 220 }}>
                <h5 style={{ color: '#222' }}>Delivery Information</h5>
                <p><strong>Name:</strong> {invoice.shipping_name}</p>
                <p><strong>Address:</strong> {invoice.shipping_address}</p>
                <p><strong>Phone:</strong> {invoice.shipping_contact}</p>
              </div>
            </div>
            <hr />
            {/* Order Summary */}
            <h5 style={{ color: '#222' }}>Order Summary</h5>
            <div style={{ width: '100%', overflowX: 'auto' }}>
              <table className="table mt-3 invoice-table-responsive" style={{ background: '#fff', color: '#222', minWidth: 600, width: '100%', tableLayout: 'fixed', wordBreak: 'break-word' }}>
                <thead style={{ background: '#fff', color: '#222' }}>
                  <tr>
                    <th style={{width: '80px'}}>Image</th>
                    <th style={{minWidth: '120px', wordBreak: 'break-word', whiteSpace: 'normal'}}>Product</th>
                    <th style={{width: '80px'}}>Quantity</th>
                    <th style={{width: '100px'}}>Unit Price</th>
                    <th style={{width: '100px'}}>Total</th>
                  </tr>
                </thead>
                <tbody>
                  {invoice.items.map((item, index) => (
                    <tr key={index} style={{ background: '#fff', color: '#222' }}>
                      <td>
                        <img
                          src={`${mainImageURI}${String(item.product_id + "_" + 0)}/${item.product_id}`}
                          alt={item.product_name}
                          style={{ width: '50px', height: '50px', objectFit: 'cover', borderRadius: 8, background: '#f0f0f0' }}
                          crossOrigin="anonymous"
                        />
                      </td>
                      <td style={{wordBreak: 'break-word', whiteSpace: 'normal'}}>{item.product_name}</td>
                      <td>{item.quantity}</td>
                      <td>${price || item.price_per_item}</td>
                      <td>${total || item.total_price}</td>
                    </tr>
                  ))}
                </tbody>
                <tfoot>
                  <tr style={{ background: '#f9f9f9', color: '#222' }}>
                    <th colSpan="2" style={{textAlign: 'left', fontWeight: 600, fontSize: '1em', padding: '0.5em', wordBreak: 'break-word', whiteSpace: 'normal'}}>Subtotal</th>
                    <th></th>
                    <th></th>
                    <th style={{textAlign: 'right', fontWeight: 600, fontSize: '1em', padding: '0.5em', wordBreak: 'break-word', whiteSpace: 'normal'}}>${total || invoice.total_amount}</th>
                  </tr>
                  <tr style={{ background: '#f9f9f9', color: '#222' }}>
                    <th colSpan="2" style={{textAlign: 'left', fontWeight: 600, fontSize: '1em', padding: '0.5em', wordBreak: 'break-word', whiteSpace: 'normal'}}>Tax</th>
                    <th></th>
                    <th></th>
                    <th style={{textAlign: 'right', fontWeight: 600, fontSize: '1em', padding: '0.5em', wordBreak: 'break-word', whiteSpace: 'normal'}}>${invoice.shipping_cost || 0}</th>
                  </tr>
                  <tr style={{ background: '#f9f9f9', color: '#222' }}>
                    <th colSpan="2" style={{textAlign: 'left', fontWeight: 700, fontSize: '1.1em', padding: '0.5em', wordBreak: 'break-word', whiteSpace: 'normal'}}>Total</th>
                    <th></th>
                    <th></th>
                    <th style={{textAlign: 'right', fontWeight: 700, fontSize: '1.1em', padding: '0.5em', wordBreak: 'break-word', whiteSpace: 'normal'}}>${total || (invoice.total_amount || 0) + (invoice.shipping_cost || 0)}</th>
                  </tr>
                </tfoot>
              </table>
            </div>
          </div>

          {/* Download Modal */}
          <Modal show={showModal} onHide={handleCloseModal}>
            <Modal.Header closeButton>
              <Modal.Title>Select Download Format</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <p>Choose your preferred format for downloading the invoice.</p>
              <Button
                style={{
                  background: "var(--primary)",
                  color: "var(--background)",
                  border: `1px solid var(--primary)`
                }}
                onClick={handleDownloadPDF}
                className="me-2"
              >
                PDF
              </Button>
              <Button
                style={{
                  background: "var(--cardBackground)",
                  color: "var(--primary)",
                  border: `1px solid var(--primary)`
                }}
                onClick={handleDownloadImage}
              >
                Image
              </Button>
            </Modal.Body>
          </Modal>
        </>
      ) : (
        <p>No invoice data available.</p>
      )}
    </div>
  );
};

export default InvoicePage;
